export default __webpack_public_path__ + "static/media/avatar_40.674d3ac8.png";